import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Svgs from '../Common/Svgs';
import {
    FormRow,
    Input,
    EditRoleSelect,
    EditCompanyAdminSelect,
    EditCompanyOwnerSelect,
    EditCompanyManagerSelect,
    EditPharmacyAdminSelect,
    EditPharmacyOwnerSelect,
    EditPharmacyManagerSelect,
    MainBtn,
    CancelBtn
} from '../Common/form/Elements-export';
import { UserRole, UserRoleValue } from '../Common/UserRole';
import { editUser } from './epics-users';
import localStorage from '../Common/LocalStorage';
import { StaticRoutePaths } from '../Common/ClientRoutes';

import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingSpinner: false,
            username: this.props.userDetails.names,
            email: this.props.userDetails.email,
            phone: this.props.userDetails.phone,
            role: this.getRoleValueHandler(this.props.userDetails.role),
            companyId: this.props.userDetails.company ? this.props.userDetails.company.id : '',
            companyName: this.props.userDetails.company ? this.props.userDetails.company.name : '',
            pharmacyId: this.props.userDetails.pharmacy ? this.props.userDetails.pharmacy.id : '',
            pharmacyName: this.props.userDetails.pharmacy ? this.props.userDetails.pharmacy.name : '',
            validation: {
                username: '',
                email: '',
                phone: '',
                role: ''
            }
        };
    }

    getUserId = () => {
        const url = this.props.location.pathname;
        return url.split('/').pop();
    };

    update = (type, property) => e => {
        if (property === 'roleSelect' && localStorage.getUsernameRole() === UserRole.ADMIN) {
            this.setState({
                ...this.state,
                [type]: e.target.value,
                company: '',
                pharmacy: ''
            });
        } else {
            this.setState({ ...this.state, [type]: e.target.value });
        }
    };

    editUserHandler = () => {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });
        editUser(this.props.userDetails.id, this.state)
            .then(() => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false
                });
                this.props.history.push(StaticRoutePaths.USERS);
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    validation: {
                        username:
                            this.generateErrorMessage(error.body, 'names')
                                .join(' ')
                                .trim() || '',
                        email:
                            this.generateErrorMessage(error.body, 'email')
                                .join(' ')
                                .trim() || '',
                        phone:
                            this.generateErrorMessage(error.body, 'phone')
                                .join(' ')
                                .trim() || '',
                        role:
                            this.generateErrorMessage(error.body, 'roles')
                                .join(' ')
                                .trim() || ''
                    }
                });
            });
    };

    generateErrorMessage = (errArray, errName) => {
        if (errArray !== null) {
            return (errArray || []).map(singleErr => {
                return singleErr.property_path === errName ? singleErr.message : '';
            });
        }
    };

    cancelUserHandler = () => {
        this.props.history.push(StaticRoutePaths.USERS);
    };

    getRoleValueHandler = roleValue => {
        switch (roleValue) {
            case UserRole.STORE_OWNER:
                return UserRoleValue.STORE_OWNER;
            case UserRole.PHARMACY_MANAGER:
                return UserRoleValue.PHARMACY_MANAGER;
            case UserRole.PHARMACIST:
                return UserRoleValue.PHARMACIST;
            default:
                return;
        }
    };

    getRoleHandler = roleValue => {
        switch (roleValue) {
            case UserRoleValue.STORE_OWNER:
                return UserRole.STORE_OWNER;
            case UserRoleValue.PHARMACY_MANAGER:
                return UserRole.PHARMACY_MANAGER;
            case UserRoleValue.PHARMACIST:
                return UserRole.PHARMACIST;
            default:
                return;
        }
    };

    getCompanyHandler = () => (this.props.companyList ? this.props.companyList[0].id : '');

    getPharmacyHandler = () => (this.props.pharmacyList ? this.props.pharmacyList[0].id : '');

    generateErrorsMessages = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    componentDidMount() {
        if (this.props.status === UserRole.ADMIN) {
            this.props.update('companyList', this.getUserId(), this.getRoleHandler(this.state.role));
            this.props.update('pharmacyList', this.getUserId(), this.state.companyId, this.getRoleHandler(this.state.role));
        }

        if (this.props.status === UserRole.STORE_OWNER) {
            this.setState({
                ...this.state,
                company: this.getCompanyHandler()
            });
            this.props.update('pharmacyList', this.getUserId(), this.state.companyId, this.getRoleHandler(this.state.role));
        }

        if (this.props.status === UserRole.PHARMACY_MANAGER) {
            this.setState({
                ...this.state,
                role: UserRoleValue.PHARMACIST,
                company: this.getCompanyHandler(),
                pharmacy: this.getPharmacyHandler()
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.role !== prevState.role) {
            this.props.update('companyList', this.getUserId(), this.getRoleHandler(this.state.role));
            this.props.update('pharmacyList', this.getUserId(), this.state.companyId, this.getRoleHandler(this.state.role));
        }
        if (this.state.companyId !== prevState.companyId) {
            this.props.update('pharmacyList', this.getUserId(), this.state.companyId, this.getRoleHandler(this.state.role));
        }
    }

    generateCompanySelect = userRole => {
        switch (userRole) {
            case UserRole.ADMIN:
                return (
                    <EditCompanyAdminSelect
                        {...this.props}
                        companyList={this.props.companyList.companies}
                        type="company"
                        handler={this.update('company')}
                        label={`* ${strings.Company}`}
                        companyId={this.state.companyId}
                        extraClasses="col-4"
                    />
                );

            case UserRole.STORE_OWNER:
                return (
                    <EditCompanyOwnerSelect
                        {...this.props}
                        companyList={this.props.companyList.companies}
                        type="company"
                        handler={this.update('company')}
                        label={`* ${strings.Company}`}
                        placeholder={this.state.companyId ? this.state.companyName : strings.select_company}
                        extraClasses="col-4"
                    />
                );

            case UserRole.PHARMACY_MANAGER:
                return (
                    <EditCompanyManagerSelect
                        {...this.props}
                        companyList={this.props.companyList.companies}
                        type="company"
                        handler={this.update('company')}
                        label={`* ${strings.Company}`}
                        placeholder={this.state.companyId ? this.state.companyName : strings.select_company}
                        extraClasses="col-4"
                    />
                );
            default:
                return;
        }
    };

    generatePharmacySelect = userRole => {
        switch (userRole) {
            case UserRole.ADMIN:
                return (
                    <EditPharmacyAdminSelect
                        {...this.props}
                        type="pharmacy"
                        label={`* ${strings.Pharmacy}`}
                        handler={this.update('pharmacy')}
                        role={this.state.role}
                        pharmacyId={this.state.pharmacyId}
                        extraClasses="col-4"
                    />
                );
            case UserRole.STORE_OWNER:
                return (
                    <EditPharmacyOwnerSelect
                        {...this.props}
                        type="pharmacy"
                        label={`* ${strings.Pharmacy}`}
                        handler={this.update('pharmacy')}
                        placeholder={this.state.pharmacyId ? this.state.pharmacyName : strings.Select_pharmacy}
                        extraClasses="col-4"
                        selectDefault={strings.Select_pharmacy}
                    />
                );
            case UserRole.PHARMACY_MANAGER:
                return (
                    <EditPharmacyManagerSelect
                        {...this.props}
                        type="pharmacy"
                        label={`* ${strings.Pharmacy}`}
                        handler={this.update('pharmacy')}
                        placeholder={this.state.pharmacyId ? this.state.pharmacyName : strings.Select_pharmacy}
                        extraClasses="col-4"
                    />
                );
            default:
                return;
        }
    };

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.users}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-pencil-square mr-2" />
                                    {strings.Edit_User}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.USERS} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />
                                    {strings.back}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>

                        <FormRow>
                            <Input
                                label={`* ${strings.Name}`}
                                handler={this.update('username')}
                                placeholder={strings.User_Full_name}
                                value={this.state.username ? this.state.username : ''}
                                extraClasses="col-8"
                            />
                            <EditRoleSelect
                                {...this.props}
                                editable={true}
                                type="role"
                                handler={this.update('role', 'roleSelect')}
                                label={`* ${strings.Role}`}
                                placeholder={this.props.userDetails ? this.props.userDetails.role : ''}
                                extraClasses="col-4"
                            />
                            <div className="col-8">{this.generateErrorsMessages(this.state.validation.username)}</div>
                            <div className="col-4">{this.generateErrorsMessages(this.state.validation.role)}</div>
                        </FormRow>

                        <FormRow>
                            <Input
                                label={`* ${strings.Email}`}
                                handler={this.update('email')}
                                placeholder={strings.user_email_placeholder}
                                value={this.state.email ? this.state.email : ''}
                                extraClasses="col-8"
                            />
                            {this.generateCompanySelect(localStorage.getFromStorage('role'))}
                            <div className="col-8">{this.generateErrorsMessages(this.state.validation.email)}</div>
                            <div className="col-4"> {this.generateErrorsMessages(this.state.validation.company)}</div>
                        </FormRow>

                        <FormRow>
                            <Input
                                label={`* ${strings.phone}`}
                                handler={this.update('phone')}
                                placeholder={strings.work_phone}
                                value={this.state.phone ? this.state.phone : ''}
                                extraClasses="col-8"
                            />
                            {this.generatePharmacySelect(localStorage.getFromStorage('role'))}
                            <div className="col-8">{this.generateErrorsMessages(this.state.validation.phone)}</div>
                            <div className="col-4"> {this.generateErrorsMessages(this.state.validation.pharmacy)}</div>
                        </FormRow>
                        <FormRow>
                            <div className="col-2 offset-8 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="px-5 text-center p-3" />
                                ) : (
                                    <CancelBtn
                                        onclick={this.cancelUserHandler}
                                        title={strings.cancel}
                                        extraClasses="qf-gray-btn w-100 mt-4"
                                    />
                                )}
                            </div>

                            <div className="col-2 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="col-11 white-bg px-5 text-center p-3">
                                        <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                                    </div>
                                ) : (
                                    <MainBtn
                                        onclick={this.editUserHandler}
                                        title={strings.Save_user}
                                        extraClasses="qf-blue-btn w-100 mt-4"
                                    />
                                )}
                            </div>
                        </FormRow>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(EditUser);



// WEBPACK FOOTER //
// ./src/customModules/Users/component-edit-user.js